import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { ModalService } from '../../../common/service/modal.service';
import { ModalRouteService } from '../../../common/service/modal-route.service';

@Component({
  selector: 'payment-update',
  templateUrl: './app.component.html',
})
export class PaymentUpdateComponent {
  @Input() dismiss;
  routeSubscription: Subscription;
  route: string = 'payment-form';
  policyType: string;
  isCoverpath: boolean = false;
  data;

  constructor(
    private modalService: ModalService,
    private modalRouteService: ModalRouteService,
    private cdRef: ChangeDetectorRef
  ) {
    this.routeSubscription = this.modalRouteService.routeSubject.subscribe((route) => {
      this.route = route;
    });
  }

  ngOnInit() {
    if (this.data.policyType) {
      this.policyType = this.data.policyType;
      this.isCoverpath = true;
    }
    this.cdRef.detectChanges();
    this.modalService.close = this.dismiss;
  }

  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }
}
